import { ExportService } from "./services/ExportService";

const apiUrl = process.env.REACT_APP_API_URL;

export const exportService = new ExportService(apiUrl);
